import { OfferingType, getAccountType } from './offeringType';
import _ from 'lodash';
import consumerProducts from './consumerProducts';
import { getAccountId } from './helpers';

// Declare gTM dataLayer array.
declare global {
	interface Window {
		dataLayer: any[];
	}
}

export const gaSendUserLogin = (accountId: string | null, offeringType: OfferingType) => {
	window?.dataLayer?.push({
		userID: accountId,
		customerType: getAccountType(offeringType),
		privateCustomerClass: offeringType
	});
};

export const gaB2BActivateSim = (monthlyRevenue: number) => {
	window?.dataLayer?.push({
		event: 'activateSim',
		monthlyRevenue // if possible, send in the value of the added monthly subscription that will be added to this sim
	});
};

export const gaB2BOrderMoreSims = (newSimsCount: number = 1, revenuePerSim: number) => {
	window?.dataLayer?.push({
		event: 'orderSims',
		countSims: newSimsCount,
		revenue: revenuePerSim * newSimsCount // price of the sims
	});
};

export const gaB2CChangeSubscriptionType = (currentOrderItemCode: string, newOrderItemCode: string, priceChange: number) => {
	window?.dataLayer?.push({
		event: 'subscriptionTypeChange',
		oldSubscription: currentOrderItemCode,
		newSubscription: newOrderItemCode,
		priceChange: priceChange // <NewPrice – OldPrice> //send as integer without € symbol, can be negative
	});
};

export const gaToggleAnsweringMachine = (newValue: boolean, priceChange: number) => {
	window?.dataLayer?.push({
		event: 'answeringMachineToggle',
		toggleDirection: newValue ? 'On' : 'Off',
		value: priceChange // +- X euros
	});
};

export const gaB2BToggleUnlimitedData = (newValue: boolean, priceChange: number) => {
	window?.dataLayer?.push({
		event: 'unlimitedDataToggle',
		toggleDirection: newValue ? 'On' : 'Off',
		value: priceChange // +- X euros
	});
};

export const gaB2BChangeOrder = (numberOfAffectedSimsOnAccount: number, changeInSubscriptionRevenue: number) => {
	window?.dataLayer?.push({
		event: 'changeSubscription',
		countSims: numberOfAffectedSimsOnAccount,
		changeInSubscriptionRevenue: changeInSubscriptionRevenue //change In The Price Of Individual Subscription, i.e. new price - old price
	});
};

export const gaB2COrderMoreSubscriptions = (subscriptions: any, pricePerMonth: number) => {
	const groupedSubscriptions = _.groupBy(subscriptions, 'packageSpecs.value.orderItemCode');
	const items: {
		item_name: any;
		item_id: string;
		price: string;
		item_brand: string;
		item_category: string;
		// item_variant: 'Gray', //omit for now
		quantity: number;
		// item_coupon: '' //omit
	}[] = [];

	_.forEach(groupedSubscriptions, (value, key) => {
		const packageSpecs = value[0].packageSpecs.value;
		const quantity = value.length;
		items.push({
			item_name: consumerProducts.getOrderItemName(key),
			item_id: key,
			price: packageSpecs.eurPerMonth,
			item_brand: 'Moi',
			item_category: 'Liittymät',
			// item_variant: 'Gray', //omit for now
			quantity
			// item_coupon: '' //omit
		});
	});
	const shipping = consumerProducts.getShippingPrice();
	const totalRevenue = pricePerMonth + shipping;
	const tax = totalRevenue - totalRevenue / (1 + consumerProducts.getTaxRate());

	window?.dataLayer?.push({
		event: 'purchase',
		ecommerce: {
			purchase: {
				transaction_id: getAccountId() + '-' + Date.now(),
				// affiliation: 'Online Store', // not relevant, omit
				value: totalRevenue.toString(),
				tax: tax.toString(),
				shipping: shipping.toString(),
				currency: 'EUR',
				// coupon: 'SUMMER_SALE', //not relevant for now, omit (if there is an option to add a coupon code, then use it
				items
			}
		}
	});
};
